import styles from './UtilityBar.module.scss';

interface UtilityBarProps {
  children: React.ReactNode;
  label: string;
}

export const UtilityBar: React.FC<UtilityBarProps> = ({ children, label }) => (
  <div className={styles.bar}>
    <p className={styles.label}>{label}</p>
    {children}
  </div>
);
